// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"835":"b53fd714f9ac7dcd","2760":"53a9f7fc8b5f023a","5510":"69987afe2f5fe7b5","7622":"8931370847558e39","7758":"683e10fed848f407","8973":"66fb8d442a1af5a8"}[chunkId] + ".js";
};